import { useMutation } from '@apollo/client';

import { UpdatePlaceInput } from '../../apollo/__generated__/graphql';
import { UPDATE_PLACE } from '../graphql/mutation/updatePlaceMutation.graphql';

export const useUpdatePlaceMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(UPDATE_PLACE, { onCompleted });

  const updatePlace = (updatePlaceInput: UpdatePlaceInput) => {
    mutate({
      variables: {
        updatePlaceInput,
      },
    });
  };

  return { updatePlace };
};
